module.exports = __webpack_public_path__ + "static/media/24UHCHR26.fd8967e9.jpg";